export default "__VITE_ASSET__3TwQpx$f__";